import {
  LuChartColumn, LuCirclePlus, LuClipboardCheck, LuClipboardList, LuFolderArchive, LuGitBranch,
  LuLandmark, LuLayoutTemplate, LuListChecks, LuListFilter, LuShieldCheck, LuUpload, LuUserCog,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
// `exact` keeps detail pages (/compliance/matrices/12, /compliance/templates/3)
// from starting a tab tour whose targets are not there.
const tours = [
  tour('compliance', '/compliance', 'regulatory', [
    ['tabs', 'compliance.tabs', LuShieldCheck],
    ['new', 'compliance.new', LuCirclePlus, opt],
    ['kpis', 'compliance.kpis', LuChartColumn, opt],
    ['work', 'compliance.work', LuClipboardList, { placement: 'top', ...opt }],
  ], { exact: true }),
  tour('compliance_matrices', '/compliance/matrices', 'regulatory', [
    ['filters', 'compliance_matrices.filters', LuListFilter],
    ['list', 'compliance_matrices.list', LuClipboardCheck, { placement: 'top', ...opt }],
    ['new', 'compliance_matrices.new', LuCirclePlus, opt],
  ], { exact: true }),
  tour('compliance_review', '/compliance/review', 'regulatory', [
    ['matrices', 'compliance_review.matrices', LuClipboardCheck],
    ['clauses', 'compliance_review.clauses', LuListChecks, { placement: 'top', ...opt }],
  ], { exact: true }),
  tour('compliance_templates', '/compliance/templates', 'regulatory', [
    ['filters', 'compliance_templates.filters', LuListFilter],
    ['list', 'compliance_templates.list', LuLayoutTemplate, { placement: 'top', ...opt }],
    ['new', 'compliance_templates.new', LuCirclePlus, opt],
  ], { exact: true }),
  tour('compliance_evidence', '/compliance/evidence', 'regulatory', [
    ['filters', 'compliance_evidence.filters', LuListFilter],
    ['list', 'compliance_evidence.list', LuFolderArchive, { placement: 'top', ...opt }],
    ['upload', 'compliance_evidence.upload', LuUpload, opt],
  ], { exact: true }),
  tour('compliance_settings', '/compliance/settings', 'regulatory', [
    ['authorities', 'compliance_settings.authorities', LuLandmark, { placement: 'right' }],
    ['policies', 'compliance_settings.policies', LuGitBranch, { placement: 'left', ...opt }],
    ['roles', 'compliance_settings.roles', LuUserCog, { placement: 'top', ...opt }],
  ], { exact: true }),
];

export default tours;
